import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-protesto-estadual',
  templateUrl: './protesto-estadual.component.html',
  styleUrls: ['./protesto-estadual.component.css', './../fdnet.component.css']
})
export class ProtestoEstadualComponent implements OnInit {

  @Input() dados: any;
  public naoSolicitou: Boolean = false;
  public naoEncontrouRegistros: Boolean = false;

  constructor() { }

  ngOnInit() {
    if (this.dados.protesto.registro.length > 0) {
      this.naoEncontrouRegistros = true;
    }
  }

}
